import store from '@/plugins/store';
import { apiPost, apiGet } from '@/api';

const routerOptions = {
  mode: 'history',
  base: '/public/app/',
  routes: [
    {
      path: '/login/:companyId',
      name: 'login',
      component: () => import('@/components/Login'),
      meta: {
        public: true,
      },
    },
    {
      path: '/signfiles/new/:id?',
      name: 'newFileSigningProcess',
      component: () => import('@/components/NewFileSigningProcess'),
      meta: {
        public: false,
      },
    },
    {
      path: '/signfiles/:id',
      name: 'signfiles',
      component: () => import('@/components/SignFiles'),
      meta: {
        public: true,
      },
    },
    {
      path: '/trade-details/:id',
      name: 'tradeDetails',
      component: () => import('@/views/TradeDetails'),
      meta: {
        public: true,
      },
    },
    {
      path: '/filesignlist/:id?',
      name: 'fileSignList',
      component: () => import('@/components/FileSignList'),
      meta: {
        public: false,
      },
    },
    {
      path: '/nets',
      name: 'nets',
      meta: {
        public: true,
      },
      beforeEnter: async (to, from, next) => {
        const { nonce, code, state } = to.query;
        let response;
        if (state.includes('doc') || state.includes('agreement') || state.includes('buyorder')) {
          response = await apiPost('nets/signin', { nonce, code, state });
        } else {
          response = await apiPost('nets/authentication', { nonce, code, state });
        }

        if (response.success === 'false') {
          next({ name: 'pagenotfound' });
        }
        let url;
        const parts = state.split('_');
        if (state.includes('doc')) {
          url = `/signfiles/${parts[1]}`;
        } else if (state.includes('buyorder')) {
          url = `${parts[2]}/buyorders/${parts[1]}`;
        } else if (state.includes('agreement')) {
          let side = '';
          if (parts[4]) {
            side = `/${parts[4]}/`;
          }
          url = `/${parts[2]}/commission-agreement-preview/${parts[1]}${side}?pid=${parts[3]}`;
        } else if (code === 'cancel') {
          url = `/${parts[4]}/offer/${parts[0]}/${parts[1]}?cancel=true`;
        } else {
          url = `/${parts[4]}/offer/${parts[0]}/${parts[1]}?signature=${response.result}&response_idx=${parts[3]}`;
        }
        next({ path: url });
      },
    },
    {
      path: '/:companyId/dias/:id',
      name: 'dias',
      component: () => import('@/components/DIAS/DIAS'),
    },
    {
      path: '/:companyId/diasRealEstate/:id',
      name: 'diasRealEstate',
      component: () => import('@/components/DIAS/DIASRealEstate'),
    },
    {
      path: '/:companyId/offer/:id/new',
      name: 'newOffer',
      component: () => import('@/components/NewOffer'),
      meta: {
        public: false,
      },
    },
    {
      path: '/:companyId/offer/:id/:offerId',
      name: 'offer',
      component: () => import('@/components/Offer'),
      meta: {
        public: true,
      },
    },
    {
      path: '/:companyId/group/dashboard',
      name: 'groupDashboard',
      component: () => import('@/components/groupDashboard/GroupDashboard'),
      meta: {
        public: false,
      },
    },
    {
      path: '/:companyId/group/properties',
      name: 'groupProperties',
      component: () => import('@/components/groupDashboard/GroupProperties'),
      meta: {
        public: false,
      },
    },
    {
      path: '/:companyId/commission-agreement-preview/:id/:side?',
      name: 'commissionAgreementPreview',
      component: () => import('@/components/CommissionAgreementPreview'),
      meta: {
        public: true,
      },
    },
    {
      path: '/:companyId/buyorders/:id',
      name: 'buyorder',
      component: () => import('@/components/BuyOrder'),
      meta: {
        public: true,
      },
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetCurrentProperty');
        next();
      },
    },
    {
      path: '/:companyId/buyorders',
      name: 'buyorderlist',
      component: () => import('@/components/BuyOrderList'),
      meta: {
        public: false,
      },
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetCurrentProperty');
        next();
      },
    },
    // {
    //   path: '/:companyId/properties',
    //   name: 'properties',
    //   component: import('@/components/Properties'),
    // },
    {
      path: '/:companyId/taxtransfer/:propertyId',
      name: 'taxtransfer',
      component: () => import('@/components/TaxTransfer'),
      meta: {
        public: false,
      },
    },
    {
      path: '/:companyId/commission-agreement/:id/:side?',
      name: 'commissionAgreement',
      component: () => import('@/components/commissionAgreement/CommissionAgreement'),
      meta: {
        public: false,
      },
    },
    {
      path: '/:companyId/search-watch',
      name: 'searchWatch',
      component: () => import('@/components/searchWatch/SearchWatchList'),
      props: {
        group: false,
      },
      meta: {
        public: false,
      },
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetCurrentProperty');
        next();
      },
    },
    {
      path: '/:companyId/search-watch-form',
      name: 'searchWatchForm',
      component: () => import('@/components/searchWatch/SearchWatch'),
      props: {
        type: 'form',
        group: false,
      },
      meta: {
        hideDashboard: true,
        public: true,
      },
    },
    {
      path: '/:companyId/search-watch/email/:hash',
      name: 'searchWatchEmail',
      beforeEnter: async (to, from, next) => {
        const data = await store.dispatch('searchWatch/getOne', { id: to.params.hash, type: 'hash' });

        if (data.id) {
          next({
            name: 'searchWatchManagement',
            params: {
              companyId: to.params.companyId,
              watchId: data.id,
            },
          });
        } else {
          next({ name: 'pagenotfound' });
        }
      },
      meta: {
        hideDashboard: true,
        public: true,
      },
    },
    {
      path: '/:companyId/search-watch/management/:watchId',
      name: 'searchWatchManagement',
      component: () => import('@/components/searchWatch/SearchWatchManagement'),
      props: {
        group: false,
      },
      meta: {
        hideDashboard: true,
        public: true,
      },
    },
    {
      path: '/groups/:groupId/search-watch-form',
      name: 'groupSearchWatch',
      component: () => import('@/components/searchWatch/SearchWatch'),
      props: {
        type: 'form',
        group: true,
      },
      meta: {
        public: true,
        hideDashboard: true,
      },
      beforeEnter: async (to, from, next) => {
        // get companies for the group
        await store.dispatch('getCompanies', to.params.groupId);
        next();
      },
    },
    {
      path: '/file-verification/:hash',
      name: 'fileVerification',
      component: () => import('@/components/FileVerification'),
      meta: {
        public: true,
        hideDashboard: true,
      },
      beforeEnter: async (to, from, next) => {
        const response = await apiGet(`attachments/verification/${to.params.hash}`);

        if (response.success) {
          next();
        } else {
          next({ name: 'fileVerificationExpired' });
        }
      },
    },
    {
      path: '/file-verification-expired',
      name: 'fileVerificationExpired',
      component: () => import('@/components/FileVerificationExpired'),
      meta: {
        public: true,
        hideDashboard: true,
      },
    },
    {
      path: '/signature-report',
      name: 'signaturereport',
      component: () => import('@/components/SignatureReport'),
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetCurrentProperty');
        next();
      },
    },
    {
      path: '/verifications',
      name: 'verifications',
      component: () => import('@/components/Verifications'),
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetCurrentProperty');
        next();
      },
      meta: {
        hideDashboard: true,
      },
    },
    // {
    //   path: '/importer',
    //   name: 'importer',
    //   component: () => import('@/components/importer/Importer'),
    // },
    {
      path: '/:companyId/profile',
      name: 'profile',
      component: () => import('@/components/Profile'),
      beforeEnter: async (to, from, next) => {
        await store.dispatch('resetCurrentProperty');
        next();
      },
    },
    {
      path: '/:companyId/slide-show',
      name: 'slideShow',
      component: () => import('@/components/Slideshow'),
      meta: {
        public: true,
        hideDashboard: true,
      },
    },
    {
      path: '*',
      name: 'pagenotfound',
      component: () => import('@/components/PageNotFound'),
      meta: {
        public: true,
      },
    },
  ],
};

export default routerOptions;
